import React from 'react'

/**
 * Chip — small status pill with a leading dot. Used for Jira type/status
 * in the document eyebrow.
 */
export function Chip({ children, className = '' }) {
  const cls = ['chip', className].filter(Boolean).join(' ')
  return (
    <span className={cls}>
      <span className="chip-dot" />
      {children}
    </span>
  )
}
